import dateService from '@gem/services/date-service';

import Tasks from 'APP/Tasks';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function sendDraftArticle(
  groupId: string,
  draftId: string,
  clientUuid: string,
  payload: ArticlePayload
): Promise<void> {
  const canSend = Tasks.messaging.canSendMessage({ groupId, payload });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return;
  }

  await Tasks.drafts.sendDraft(
    groupId,
    new ChatMessage({
      id: draftId,
      groupId,
      clientTime: dateService.now().getTime(),
      clientUuid,
      payload: payload.toJSON(),
    })
  );
}
